<script lang="ts">
    import NauiFieldsetTable from "../../naui/components/NauiFieldsetTable.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import type {ITablePreview} from "../../interfaces/table-preview.interface";
    import {createEventDispatcher, onMount} from "svelte";
    import LoadingBackground from "../components/modals/LoadingBackground.svelte";
    import ItemMaestra from "../ItemMaestra.svelte";

    const dispatcher = createEventDispatcher();
    export let fieldsets = [];

    export let table: ITablePreview /*= {
        header: [
            {
                label: 'Lorem',
                slug: 'opt1'
            },
            {
                label: 'Lorem 2',
                slug: 'opt2'
            }
        ],
        body: [
            {
                opt1: 'Lorem 1',
                opt2: 'Lorem 2'
            }
        ]
    }*/

    export let modal: any;

    export let canDelete: boolean = false;
    export let canEdit: boolean = false;

    export let loading: boolean = false;

    export let cargaMaestra: any;

    function save() {
        const obj = fieldsets.reduce((acc: any, item: any) => {
            item.fields.forEach((f: any) => acc[f.slug] = f.value);
            return acc;
        }, {});
        dispatcher('save', obj);
        loading = true;
    }

    function doDelete() {
    }

    function accept() {
        dispatcher('back')
    }
</script>

<div>
    <div class="grid-7-5 gap-3">
        <div class="left">
            {#each fieldsets || [] as fieldset}
                <NauiFieldsetTable title={fieldset.title}
                                   fields="{fieldset.fields || []}"/>
            {/each}
        </div>
        <div class="right relative">
            <div class="right-content sticky">
                {#if cargaMaestra}
                    <ItemMaestra {cargaMaestra}
                                 on:back={()=>accept()}/>
                {:else}
                    <div class="box-l sx-1">
                        {#if canDelete}
                            <NauiButton caption="ELIMINAR"
                                        mode="outline"
                                        color="accent"
                                        on:click={doDelete}/>
                            <NauiButton/>
                        {/if}
                        {#if canEdit}
                            <NauiButton caption="GUARDAR"
                                        mode="solid"
                                        color="accent"
                                        on:click={save}/>
                            <NauiButton/>
                        {/if}
                    </div>
                {/if}
            </div>
        </div>
    </div>
    {#if table}
        <div class="mt-2">
            <fieldset>
                <legend class="mb-0">Previsualización de datos</legend>
            </fieldset>
            <div>
                <table class="naui-table w-100">
                    <thead>
                    <tr>
                        {#each table?.header as head}
                            <th>
                                <div>
                                    {head.label}
                                </div>
                            </th>
                        {/each}
                    </tr>
                    </thead>
                    <tbody>
                    {#each table?.body as row}
                        {#each table?.header as head}
                            <td>
                                <div>
                                    {row[head.slug]}
                                </div>
                            </td>
                        {/each}
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    {/if}
</div>

{#if loading}
    <LoadingBackground/>
{/if}